import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors } from 'yoda-ui/yodaTheme';

export const loaderWrapperStyle: SxProps<Theme> = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  zIndex: 5,
  alignItems: 'center',
  background: YodaColors.gray0,
  opacity: 0.75,
};
